import { render, staticRenderFns } from "./fieldNumero.vue?vue&type=template&id=2c258a2c"
import script from "./fieldNumero.vue?vue&type=script&lang=js"
export * from "./fieldNumero.vue?vue&type=script&lang=js"
import style0 from "./fieldNumero.vue?vue&type=style&index=0&id=2c258a2c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c258a2c')) {
      api.createRecord('2c258a2c', component.options)
    } else {
      api.reload('2c258a2c', component.options)
    }
    module.hot.accept("./fieldNumero.vue?vue&type=template&id=2c258a2c", function () {
      api.rerender('2c258a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldNumero.vue"
export default component.exports